import Vue from 'vue'

export default {
  getCustomerReferrals(customerId) {
    return Vue.http.get(`referrals/${customerId}`).then(res => res.body)
  }
}
